// import React from "react";
// import { Card } from "react-bootstrap";
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

// const ContactUs = ({ reviews }: any) => {
//   return (
//     <React.Fragment>
//       <ResponsiveMasonry
//         className="row mx-1"
//         style={{ position: "relative", height: "814.125px" }}
//         data-masonry='{"percentPosition": true }'
//         columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}
//       >
//         <Masonry
//           className="col-xxl-3 col-lg-4 col-md-6"
//           style={{ position: "absolute", top: "0px", left: "0%" }}
//         >
//           {(reviews || []).map((item: any, key: number) => (
//             <Card className="mx-2 my-2" key={key}>
//               <Card.Body>
//                 <img src={item.img} alt="" className="avatar-sm rounded" />
//                 <h5 className="mb-2 mt-3">{item.name}</h5>
//                 <div className="text-warning mb-3">
//                   <i className="ri-star-s-fill"></i>
//                   <i className="ri-star-s-fill"></i>
//                   <i className="ri-star-s-fill"></i>
//                   <i className="ri-star-s-fill"></i>
//                   <i className="ri-star-s-fill"></i>
//                 </div>
//                 <p className="mb-0 text-muted fs-15">{item.subTitle}</p>
//               </Card.Body>
//             </Card>
//           ))}
//         </Masonry>
//       </ResponsiveMasonry>
//     </React.Fragment>
//   );
// };

// export default ContactUs;

import React, { useState, useEffect } from "react";
import { Card, Modal, Button } from "react-bootstrap";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"; // Update the import path
import { deleteContact, getAllContacts, getContactById } from "api/apis";
import { Contact } from "interface";

// interface Contact {
//   _id: string;
//   name: string;
//   email: string;
//   message: string;
//   createdAt: string;
// }

const ContactUs = () => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const data = await getAllContacts();
      console.log("Contact: ", data);
      setContacts(data);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  const handleCardClick = async (id: string) => {
    try {
      const contact = await getContactById(id);
      setSelectedContact(contact);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching contact details:", error);
    }
  };

  const handleDeleteContact = async (id: string) => {
    try {
      await deleteContact(id);
      setContacts(contacts.filter((contact) => contact._id !== id));
      setShowModal(false);
    } catch (error) {
      console.error("Error deleting contact:", error);
    }
  };

  const getFirstLineOfMessage = (message: string) => {
    return message.split("\n")[0].substring(0, 100); // Get first line and limit to 100 chars
  };

  return (
    <React.Fragment>
      <ResponsiveMasonry
        className="row mx-1"
        data-masonry='{"percentPosition": true }'
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}
      >
        <Masonry className="col-xxl-3 col-lg-4 col-md-6">
          {(contacts || []).map((item) => (
            <Card
              className="mx-2 my-2"
              key={item._id}
              onClick={() => handleCardClick(item._id)}
              style={{ cursor: "pointer" }}
            >
              <Card.Body>
                <h5 className="mb-2">{item.name}</h5>
                <p className="text-muted mb-2">{item.email}</p>
                <p className="mb-0 text-muted fs-15">
                  {getFirstLineOfMessage(item.message)}
                  {item.message.length > 100 && "..."}
                </p>
              </Card.Body>
            </Card>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {/* Modal for detailed view */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Contact Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedContact && (
            <div>
              <h5>{selectedContact.name}</h5>
              <p className="text-muted mb-3">{selectedContact.email}</p>
              <p className="mb-3">
                Sent: {new Date(selectedContact.createdAt).toLocaleString()}
              </p>
              <div className="border-top pt-3">
                <p>{selectedContact.message}</p>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() =>
              selectedContact && setConfirmDeleteId(selectedContact._id)
            }
          >
            Delete
          </Button>

          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!confirmDeleteId}
        onHide={() => setConfirmDeleteId(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this contact?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmDeleteId(null)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              if (confirmDeleteId) {
                handleDeleteContact(confirmDeleteId);
                setConfirmDeleteId(null);
              }
            }}
          >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ContactUs;
